import React from 'react'
import Layout from '../../shared/components/organisms/layout/layout'
import SEO from "../../shared/seo";
import ConsultingRoomContent from '../organisms/consulting-room-content/consulting-room-content';

const ConsultingRoomTemplate = (props) => {

    const { pageContext } = props;

    var otherMeta = [
        {
            property: `og:url`,
            content: typeof window !== "undefined" ? window.location.href : '',
        }
        // ,
        // {
        //     property: `og:image`,
        //     content: props.pageContext.params.imagenPrediccionDelDia.file.url,
        // }

    ]
    // send active modal to layout
    const [modalActive, setModalActive] = React.useState();
    // var news_info=props.dataProp
    const [isMobile, setMobileBool] = React.useState(false);
    // send active modal to layout
    const updateDimensions = () => {
        setMobileBool(window.innerWidth < 1024 ? true : false);
    }
    React.useEffect(() => {
        updateDimensions();
        window.addEventListener("resize", updateDimensions);
        return () => {
            window.removeEventListener("resize", updateDimensions);
        }
    }, [])

    return (
        <Layout
            mobile={isMobile}
            modalActive={modalActive}
        >
            <SEO
                title={pageContext.params.titulo}
                // description={props.pageContext.params.metaDescripcion.metaDescripcion}
                meta={otherMeta}
            />
            <ConsultingRoomContent menu={pageContext.menu} context={pageContext.params} setModalActive={setModalActive} mobile={isMobile} />
        </Layout>
    )
}

export default ConsultingRoomTemplate
